export default __webpack_public_path__ + "static/Judah Finkelstein-393c2426d1dd4bd8c8e660bd346b0fe2.png";